
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_19937_132449)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.627 15.347h5.312V5.034a.935.935 0 00-.937-.937H4.377a.935.935 0 00-.938.937V20.66c0 .52.418.938.938.938H14.69v-5.313a.94.94 0 01.937-.937zm5.039 2.148l-3.828 3.828a.937.937 0 01-.664.274h-.234v-5h5v.238a.934.934 0 01-.274.66zm-4.218-7.386H7.93v-2h8.518v2zM7.93 13.917h4.26v-2H7.93v2z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_19937_132449"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(3.44 2.847)","d":"M0 0h17.5v20H0z"}})])])])
          )
        }
      }
    